import React, { Component, Fragment } from 'react';
import { Wrapper, Container, Text } from './styled/ErrorMessageStyled';

interface ErrorMessageProps {
    errorCode?: number | null;
    countdown: number;
    localization: { getText: (key: string, options?: Record<string, string | number | boolean | null | undefined>) => string };
}

class ErrorMessage extends Component<ErrorMessageProps> {
    static defaultProps = {
        errorCode: null
    };

    _getContent = () => {
        const { errorCode, localization, countdown } = this.props;
        return (
            <Fragment>
                <div>{localization.getText(`errors.${errorCode}`)}</div>
                {countdown > 0 && <div>{localization.getText('reconnect.retry', { countdown })}</div>}
            </Fragment>
        );
    };

    render() {
        return (
            <Wrapper>
                <Container>
                    <Text>{this._getContent()}</Text>
                </Container>
            </Wrapper>
        );
    }
}

export default ErrorMessage;
